(function () {
  var reduceMotionPref = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Tab switching ---- */
  var sections = document.querySelectorAll('[data-bd-tabs]');

  sections.forEach(function (section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-bd-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-bd-panel]'));
    var viewAllBtn = section.querySelector('[data-bd-tabs-viewall]');
    var navWrap = section.querySelector('[data-bd-tabs-nav-wrap]');

    /* Link every tab to its panel for screen readers */
    tabs.forEach(function (tab) {
      var panelId = tab.getAttribute('data-panel');
      var panel = document.getElementById(panelId);

      if (!tab.id) {
        tab.id = 'bd-tab-' + panelId.replace('bd-panel-', '');
      }

      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('tabindex', tab.classList.contains('is-active') ? '0' : '-1');

      if (panel) {
        panel.setAttribute('aria-labelledby', tab.id);
      }
    });

    /* On mobile the tab row is a horizontal scroller: keep the
       selected tab comfortably in view (centered when possible). */
    function centerTab(tab) {
      if (!navWrap || navWrap.scrollWidth <= navWrap.clientWidth + 1) return;

      var wrapRect = navWrap.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      var delta = (tabRect.left - wrapRect.left) - (wrapRect.width - tabRect.width) / 2;

      navWrap.scrollBy({
        left: delta,
        behavior: reduceMotionPref ? 'auto' : 'smooth'
      });
    }

    function activate(tab, moveFocus) {
      if (!tab) return;

      if (!tab.classList.contains('is-active')) {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');

        var panel = document.getElementById(tab.getAttribute('data-panel'));
        if (panel) {
          panel.classList.add('is-active');
          /* The panel was hidden (display:none) until now, so any carousel
             inside it measured 0-width on page load. Re-measure now that
             it's actually visible. */
          var carousel = panel.querySelector('[data-bd-tabs-carousel]');
          if (carousel && typeof carousel.bdMeasure === 'function') {
            carousel.bdMeasure();
          }
        }

        if (viewAllBtn) {
          var url = tab.getAttribute('data-collection-url');
          if (url) viewAllBtn.setAttribute('href', url);
        }
      }

      centerTab(tab);

      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab, false);
      });

      /* Keyboard: left / right / home / end */
      tab.addEventListener('keydown', function (e) {
        var next = null;

        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];

        if (next) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });
  });

  /* ---- Per-panel carousels (same measured-width technique as elsewhere) ---- */
  var roots = document.querySelectorAll('[data-bd-tabs-carousel]');

  roots.forEach(function (root) {
    var track = root.querySelector('[data-bd-tabs-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bd-tabs-slide]'));
    var prevBtn = root.querySelector('[data-bd-tabs-prev]');
    var nextBtn = root.querySelector('[data-bd-tabs-next]');
    var dotsWrap = root.closest('.bd-tabs__panel').querySelector('[data-bd-tabs-dots]');
    var total = slides.length;
    if (!track || !total) return;

    var slidesDesktop = parseInt(root.getAttribute('data-slides-desktop'), 10) || 4;
    var slidesMobile = parseInt(root.getAttribute('data-slides-mobile'), 10) || 1;
    var mq = window.matchMedia('(max-width: 749px)');
    var reduceMotion = reduceMotionPref;
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var autoplaySpeed = (parseFloat(root.getAttribute('data-autoplay-speed')) || 5) * 1000;
    var timerId = null;
    var isHovering = false;

    var index = 0;
    var maxIndex = 0;
    var step = 0;

    /* A carousel inside a hidden tab panel (display:none) has no layout box */
    function isVisible() {
      return root.offsetParent !== null;
    }

    function currentSlidesToShow() {
      return mq.matches ? slidesMobile : slidesDesktop;
    }

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i <= maxIndex; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bd-dot';
        dot.setAttribute('aria-label', 'Go to position ' + (i + 1));
        (function (di) {
          dot.addEventListener('click', function () {
            goTo(di);
            startAutoplay();
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function update() {
      track.style.transform = 'translateX(-' + index * step + 'px)';
      var canScroll = maxIndex > 0;
      if (prevBtn) {
        prevBtn.style.display = canScroll ? '' : 'none';
        prevBtn.disabled = index <= 0;
      }
      if (nextBtn) {
        nextBtn.style.display = canScroll ? '' : 'none';
        nextBtn.disabled = index >= maxIndex;
      }
      if (dotsWrap) {
        dotsWrap.style.display = canScroll ? '' : 'none';
        var dots = dotsWrap.querySelectorAll('.bd-dot');
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
      }
    }

    function goTo(i) {
      index = Math.max(0, Math.min(i, maxIndex));
      update();
    }

    function autoNext() {
      var next = index + 1;
      if (next > maxIndex) next = 0;
      goTo(next);
    }

    function startAutoplay() {
      if (!autoplayEnabled || maxIndex < 1) return;
      stopAutoplay();
      timerId = setInterval(function () {
        /* only rotate the panel the visitor can actually see */
        if (!isHovering && isVisible()) autoNext();
      }, autoplaySpeed);
    }
    function stopAutoplay() {
      if (timerId) clearInterval(timerId);
      timerId = null;
    }

    function measure() {
      var slidesToShow = currentSlidesToShow();
      maxIndex = Math.max(0, total - slidesToShow);
      var trackStyle = getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      var width = slides[0].getBoundingClientRect().width;
      if (width > 0) {
        step = width + gap;
      }
      index = Math.min(index, maxIndex);
      renderDots();
      update();
      startAutoplay();
    }
    root.bdMeasure = measure;

    /* resize / breakpoint change: hidden panels are re-measured when shown */
    function remeasureIfVisible() {
      if (isVisible()) measure();
    }

    root.addEventListener('mouseenter', function () {
      isHovering = true;
    });
    root.addEventListener('mouseleave', function () {
      isHovering = false;
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
        startAutoplay();
      });
    }

    var touchStartX = 0;
    var touchDeltaX = 0;
    track.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
        stopAutoplay();
      },
      { passive: true }
    );
    track.addEventListener(
      'touchmove',
      function (e) {
        touchDeltaX = e.touches[0].clientX - touchStartX;
      },
      { passive: true }
    );
    track.addEventListener('touchend', function () {
      if (Math.abs(touchDeltaX) > 40) {
        if (touchDeltaX < 0) {
          goTo(index + 1);
        } else {
          goTo(index - 1);
        }
      }
      startAutoplay();
    });

    window.addEventListener('resize', remeasureIfVisible);
    if (mq.addEventListener) {
      mq.addEventListener('change', remeasureIfVisible);
    }

    measure();
  });
})();